<template>
  <div id="splash">
    <div class="lds-ripple"><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
};
</script>

<style scoped></style>
